import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcel } from "./ExportExcel";
import { ExportPdf } from "./ExportPdf";
import { useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { TransferType } from "../types";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportTransfer(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("transfer", {
        start_date: fill.dateFrom,
        end_date: fill.dateTo,
        approval_status: fill.approval_status,
        transfer_status: fill.transfer_status,
        from_location_id: fill.from_location_id,
        to_location_id: fill.to_location_id,
        jumlah_item: amount
    })

    return (

        <ModalConfirmExport
            isOpen={true}
            setIsOpen={props.setIsOpen}
            amount={amount}
            setAmount={setAmount}
            title="Item Transfer"
            type={props.type as "excel" | "pdf"}
            total={data.total_record}
            onExport={(amount) => {
                if (props.type === "excel") {
                    ExportExcel({
                        data: data.items as TransferType[],
                        filter: {
                            dateFrom: fill.dateFrom,
                            dateTo: fill.dateTo
                        },
                        module: "INVENTORY",
                        title: "REGISTER TRANSFER",
                        fileName: "register_transfer",
                        activeColumns: activeColumn!
                    });
                }

                if (props.type === "pdf") {
                    const documentComponent = (
                        <ExportPdf data={data.items as TransferType[]} filter={fill} tableActive={activeColumn!} />
                    )
                    exportPdf({ documentComponent, fileName: "register_transfer" })
                }
            }}
        />
    )
}